import ApiClient from "@common/api/ApiClient";

class MediaClient extends ApiClient {
  constructor() {
    super("Media");
    this.setApiUrlKey("comp_api_url");
  }

  Create = async (payload, options) => {
    return await this.post(`Create`, payload, options);
  };

  Search = async (payload = { incidentId: 0 }) =>
    await this.post("Search", payload);

  Read = async (imageId = null) => await this.get(`Read?id=${imageId}`);

  Delete = async (imageId = null) => await this.get(`Delete?id=${imageId}`);
}

const client = new MediaClient();

export default client;
